import { FC, memo, useEffect, useState } from 'react';
import { arePropsEqual } from '@bridebook/web/lib/utils';
import { buildImageSrc, OPTIMIZED_IMAGE_QUALITY } from '@bridebook/toolbox/src/buildImageUrl';
import { SearchCarousel } from './search-carousel';

const IMAGE_WIDTH = 400;
const IMAGE_HEIGHT = 286;

interface CarouselGridGalleryProps {
  photos: string[];
  showGallery: boolean;
  isVenue: boolean;
  itemIndex?: number;
}

const CarouselGridGalleryComponent: FC<CarouselGridGalleryProps> = ({
  photos,
  showGallery,
  isVenue,
  itemIndex,
}) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  // On SSR: carousel shows only photo[0] when thumbnails already cover photos[1-3]
  const carousel = (
    <SearchCarousel
      photos={photos}
      isVenue={isVenue}
      maxImages={showGallery && !mounted ? 1 : undefined}
      itemIndex={itemIndex}
    />
  );

  if (photos.length > 3 && showGallery) {
    return (
      <div className="bsa">
        <div>{carousel}</div>
        {photos.slice(1, 4).map((src, index) => (
          <img
            key={index}
            src={buildImageSrc(src, {
              w: IMAGE_WIDTH,
              h: IMAGE_HEIGHT,
              fit: 'cover',
              gravity: 'face',
              quality: OPTIMIZED_IMAGE_QUALITY,
            })}
            alt=""
            loading="lazy"
          />
        ))}
      </div>
    );
  }

  return carousel;
};

export const CarouselGridGallery: FC<CarouselGridGalleryProps> = memo(
  CarouselGridGalleryComponent,
  arePropsEqual,
);
